import { render, staticRenderFns } from "./VideoTabs.vue?vue&type=template&id=8f3d8d22&"
import script from "./VideoTabs.vue?vue&type=script&lang=js&"
export * from "./VideoTabs.vue?vue&type=script&lang=js&"
import style0 from "./VideoTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports